import { css } from 'linaria';

export const card = css`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  cursor: pointer;
`;

export const card__image__container = css`
  position: relative;
  width: 100%;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
`;

export const card__caption = css`
  padding: var(--space-100) 0;
  display: flex;
  flex-direction: column;
`;

export const card__collection__title = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

export const card__image__grid = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  width: 100%;
  height: 100%;
  position: absolute;
`;

export const card__grid__image = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: var(--background-secondary);
`;

export const card__grid__fallback = css`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-secondary);
  position: relative;
  width: 100%;
  height: 100%;
`;
